export enum ShippingMethodOperations {
    GET_NA_SHIPPING_PRICES = 'getNAShippingPrices',
}